import { render, staticRenderFns } from "./grigliaUlterioriDati.vue?vue&type=template&id=818a74d4&"
import script from "./grigliaUlterioriDati.vue.ts?vue&type=script&lang=ts&"
export * from "./grigliaUlterioriDati.vue.ts?vue&type=script&lang=ts&"
import style0 from "./grigliaUlterioriDati.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports